import React from "react";
import Label from "components/general/Label"
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";



export function CompetitorBlockNoData(competitor) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let competitorPlace = competitor?.cp_code ? <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} /> : ''
    let prev_value = competitor?.cp_prev_value ? <SportCode discipline={mirs_discipline} entity='@Pool' code={competitor?.cp_prev_value} /> : ''
    let prev_wlt = competitor?.cp_prev_wlt
    let prev_pos = <>{' ' + competitor.cp_prev_pos}</>
    return (
        <div className=' d-flex flex-row justify-content-start'>
            <div className=''>
                {competitor?.cp_code === 'BYE'
                ?<SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} />
                :prev_value && !prev_wlt
                    ? prev_value
                    : competitorPlace && !prev_wlt
                        ? competitorPlace
                        : !competitor.cp_prev_wlt
                            ? competitor?.cp_prev_pos
                            : competitor?.cp_prev_wlt === 'W'
                                ? <><Label data='HeaderWinner' /><>{prev_pos}</></>
                                : <><Label data='LabelLooserDesc' /><>{prev_pos}</></>
                }
            </div>
        </div>
    )
}
